export default __webpack_public_path__ + "static/media/Program1_documents_1.129d057b.jpg";